export const config = {
  title: 'IGL',
  buttonPrimaryColor: '#009ef7',
  buttonTextPrimaryColor: '#fff',
}
